import { useEffect, useRef, useState } from 'react'

import energyIcon from '@/assets/icons/energey.svg'

import { Container, EnergyBadge, Message } from './styles'

const TOAST_VISIBLE_DURATION_MS = 3000
const EXIT_ANIMATION_DURATION_MS = 300

interface EnergyToastProps {
  message: string | null
  onDismiss: () => void
}

export default function EnergyToast({ message, onDismiss }: EnergyToastProps) {
  const [isExiting, setIsExiting] = useState(false)
  const [trackedMessage, setTrackedMessage] = useState(message)
  const onDismissRef = useRef(onDismiss)

  useEffect(() => {
    onDismissRef.current = onDismiss
  }, [onDismiss])

  if (message !== trackedMessage) {
    setTrackedMessage(message)
    setIsExiting(false)
  }

  useEffect(() => {
    if (!message) return

    const visibleTimer = setTimeout(() => {
      setIsExiting(true)
    }, TOAST_VISIBLE_DURATION_MS)

    const dismissTimer = setTimeout(() => {
      onDismissRef.current()
    }, TOAST_VISIBLE_DURATION_MS + EXIT_ANIMATION_DURATION_MS)

    return () => {
      clearTimeout(visibleTimer)
      clearTimeout(dismissTimer)
    }
  }, [message])

  if (!message) return null

  return (
    <Container isExiting={isExiting}>
      <EnergyBadge>
        <img src={energyIcon} alt='' width={18} height={18} />
      </EnergyBadge>
      <Message>{message}</Message>
    </Container>
  )
}
